export default function Header() {
  return (
    <header className="bg-blue-900 text-white p-4 flex justify-between items-center">
      <h1 className="text-xl font-bold flex">
        <img className="mr-4" src="logo.png" width={60} alt="Logo-pichinin" />
        <img src="Bosch_Logo.svg" width={60} alt="Logo" />
      </h1>
      <nav>
        <ul className="flex gap-4">
          <li>
            <a href="#sobre" className="hover:underline">
              Sobre
            </a>
          </li>
          <li>
            <a href="#servicos" className="hover:underline">
              Serviços
            </a>
          </li>
          <li>
            <a href="#contato" className="hover:underline">
              Contato
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}
